import { render } from "./User.vue?vue&type=template&id=63d0867a"
const script = {}
script.render = render

export default script